import React from "react";
import propic from "../../../assets/images/propic.jpg";
import { FaCircle } from "react-icons/fa";
const Experience = ({ classes }) => {
  return (
    <div className={`${classes}`} data-aos="zoom-in" data-aos-duration="1000">
      <div className="">
        <h3 className="text-4xl font-roboto font-extrabold text-green-500 text-end">
          <span>Experience</span>
        </h3>
        <div className="flex items-start justify-end mt-8 px-5 text-end">
            <div className="text-white text-[18px] mr-2">
                Technical Lead
                <div>
                    January 2024 To Present
                </div>
                <div>
                    Lilliput Digital
                </div>
            </div>
            <div className="text-green-500  mt-1">
                <FaCircle />
            </div>
            
        </div>

        <div className="flex items-start justify-end mt-8 px-5 text-end">
            <div className="text-white text-[18px] mr-2">
                Software Engineer
                <div>
                    February 2023 To December 2023
                </div>
                <div>
                    Lilliput Digital
                </div>
            </div>
            <div className="text-green-500  mt-1">
                <FaCircle />
            </div>
            
        </div>

        <div className="flex items-start justify-end mt-8 px-5 text-end">
            <div className="text-white text-[18px] mr-2">
                Software Engineer
                <div>
                    February 2022 To January 2023
                </div>
                <div>
                   UI Lib
                </div>
            </div>
            <div className="text-green-500  mt-1">
                <FaCircle />
            </div>
            
        </div>
      </div>
    </div>
  );
};

export default Experience;